import React, { useCallback } from 'react';
import { components } from 'react-select';

import PropTypes from 'prop-types';

import deviceImage from '@/components/SchedulePage/OrderModal/OrderForm/InspectorOption/icons/device-gray.svg';
import inspectionImage from '@/components/SchedulePage/OrderModal/OrderForm/InspectorOption/icons/inspection-gray.svg';
import locationImage from '@/components/SchedulePage/OrderModal/OrderForm/InspectorOption/icons/location-gray.svg';
import InspectorsIcon from '@/svg-icons/inspector';

const InspectorOption = ({ children, data, ...props }) => {
  const getInspectorIcon = useCallback(() => {
    if (data?.status === 'DEVICE_NOT_CONNECTED') {
      return <img className="w-4 h-4 mr-2.5" src={deviceImage} alt="dispositivo" />;
    }

    if (data?.pendingOrderBasedMessage) {
      if (data?.pendingOrderBasedMessage === 'ORDER_TYPE') {
        return <img className="w-4 h-4 mr-2.5" src={inspectionImage} alt="Tipo de vistoria" />;
      }

      if (data?.pendingOrderBasedMessage === 'ADDRESS') {
        return <img className="w-4 h-4 mr-2.5" src={locationImage} alt="Bairro" />;
      }
    }

    return (
      <span
        className="flex justify-center items-center w-[24px] h-[24px] mr-2.5 border border-[#5578a0] rounded-full"
      >
        <InspectorsIcon className="text-[12px]" />
      </span>
    );
  }, [data]);

  return (
    <components.Option className="!flex !justify-start !items-center cursor-pointer p-2" {...props}>
      {getInspectorIcon()}
      {children}
    </components.Option>
  );
};

InspectorOption.propTypes = {
  children: PropTypes.node.isRequired,
  data: PropTypes.object.isRequired,
};

export default InspectorOption;
